var _defs, _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStyleSelected(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 20,
    height: 20
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.617,13.75,11,9.941v-1.6A3.493,3.493,0,1,0,6.5,5a1,1,0,0,0,2,0A1.5,1.5,0,1,1,10,6.5a1,1,0,0,0-1,1V9.941L1.383,13.75A2.487,2.487,0,0,0,0,15.987V17a1,1,0,0,0,1,1H19a1,1,0,0,0,1-1V15.987A2.487,2.487,0,0,0,18.617,13.75ZM18,16H2v-.013a.487.487,0,0,1,.277-.449L10,11.677l7.722,3.861a.486.486,0,0,1,.278.449Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStyleSelected);
export default __webpack_public_path__ + "static/media/StyleSelected.95b1bbd41e37be1927408e68ca97ece5.svg";
export { ForwardRef as ReactComponent };